import { Injectable } from '@angular/core';
import { environment } from '@core/const';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';
import { ActivatedRouterStateSnapshot, WindowRef } from '@spartacus/core';
import { Observable, filter, map, tap } from 'rxjs';
import { CookieService } from '../services';

/**
 * Данный эффект позволяет проставить куки в браузере с помощью квери параметров.
 * Функционал особенно полезен на мобильных устройствах.
 * - установка куки: ?sdSetCookie=<key>:<value>
 * - удаление куки: (оставьте value пустым и кука будет удалена) ?sdSetCookie=<key>
 * Кука живет в течении 1 суток
 */
@Injectable()
export class SetCookieEffects {
  queryParamName = 'sdSetCookie';

  setCookie$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType<RouterNavigatedAction<ActivatedRouterStateSnapshot>>(ROUTER_NAVIGATED),
        map((action) => action.payload.routerState.queryParams[this.queryParamName]),
        filter((queryParamValue) => Boolean(queryParamValue) && !environment.production && this.winRef.isBrowser()),
        tap((queryParamValue) => {
          if (!queryParamValue) {
            this.log(`неверное значение, ожидается ${this.queryParamName}=<key>[:<value>]`);

            return;
          }

          const [key, value] = queryParamValue.trim().split(':');

          if (!key) {
            this.log(`неверное значение, ожидается ${this.queryParamName}=<key>[:<value>]`);

            return;
          }

          if (!value) {
            this.log(`значение удалено (${key})`);
            this.cookieService.remove(key);
          } else {
            this.log(`значение установлено (${key}=${value})`);
            this.cookieService.put(key, value, {
              expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 1),
            });
          }

          const url = new URL(window.location.href);
          url.searchParams.delete(this.queryParamName);
          this.winRef.nativeWindow?.location.replace(url.toString());
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private cookieService: CookieService,
    private winRef: WindowRef,
  ) {}

  log(msg: string): void {
    // eslint-disable-next-line
    console.log(`${this.queryParamName}: ${msg}`);
  }
}
